export const defaultMediaImg = {
  id: null,
  url: '',
  file: null,
  loading: false,
}

const defaultMediaButtonProps = {
  buttonName: '',
  buttonType: 'link',
}

const defaultMediaButtonLink = {
  type: 'custom',
  link: [],
  sportId: null,
}

const defaultMediaButtonDialogue = {
  title: '',
  text: '',
  hasButton: false,
}

export const defaultMediaBase = {
  image: { ...defaultMediaImg },
  completionDate: null,
  showTime: false,
  title: '',
  hasButton: false,
}

export const MEDIA_FORM_FIELDS = {
  base: { ...defaultMediaBase },
  buttonProps: {
    ...defaultMediaButtonProps,
    link: { ...defaultMediaButtonLink },
    dialogue: {
      ...defaultMediaButtonDialogue,
      image: { ...defaultMediaImg },
      link: { ...defaultMediaButtonLink },
    },
  },
}
